//@ts-check
import SmrClient from "Utils/Requests/SmrClient";

class MetricsRequests {
    /**
    * @param {number} start
    * @param {number} length
    * @param {string} searchString
    * @param {boolean} skipError
    * @returns {Promise<{countTotal: number, rowsDataForPageOrAll: WebMetricUser[], hasActive: boolean}>}
    */
    async GetMetricUsers(start, length, searchString, skipError) {
        return await SmrClient.FetchJson({
            url: 'Metric/GetMetricUsers',
            method: 'POST',
            body: { start, length, searchString },
            bodyIsUrlParams: true,
            skipError: skipError
        });
    }

    /**
    * @param {number} start
    * @param {number} length
    * @param {string} searchString
    * @param {boolean} skipError
    * @returns {Promise<{countTotal: number, rowsDataForPageOrAll: WebMetricUserDL[], hasActive: boolean}>}
    */
    async GetMetricUserDLs(start, length, searchString, skipError) {
        return await SmrClient.FetchJson({
            url: 'Metric/GetMetricUserDLs',
            method: 'POST',
            body: { start, length, searchString },
            bodyIsUrlParams: true,
            skipError: skipError
        });
    }

    /**
     * @param {number} metricUserId
     * @param {number} userId 
     * @returns {Promise<{ userTitle: string | null }>}
     */
    async GetMetricUserInfo(metricUserId, userId) {
        return await SmrClient.FetchJson({
            url: 'Metric/GetMetricUserInfo',
            method: 'POST',
            body: { metricUserId, userId },
            bodyIsUrlParams: true,
        });
    }

    /**
     * @param {number} metricUserDLId
     * @param {number} contactId 
     * @returns {Promise<{ userTitle: string | null }>}
     */
    async GetMetricUserDLInfo(metricUserDLId, contactId) {
        return await SmrClient.FetchJson({
            url: 'Metric/GetMetricUserDLInfo',
            method: 'POST',
            body: { metricUserDLId, contactId },
            bodyIsUrlParams: true,
        });
    }

    async GetInitData() {
        return await SmrClient.FetchJson({
            url: 'Metric/GetInitData',
            method: 'GET'
        });
    }

    /**
     * @param {WebMetricFilters} filters
     * @param {number[]} metricUserIds
     * @returns {Promise<{ data: WebMetricUserOrUserDlData[] }>}
     */
    async GetData(filters, metricUserIds) {
        return await SmrClient.FetchJson({
            url: 'Metric/GetData',
            method: 'POST',
            body: { filters, metricUserIds }
        });
    }

    /**
     * @param {WebMetricFilters} filters
     * @param {number[] | null} metricUserIds
     */
    async ExportUsersData(filters, metricUserIds) {
        return await SmrClient.FetchDownload({
            url: 'Metric/ExportUsersData',
            method: 'POST',
            body: { filters, metricUserIds }
        });
    }

    /**
     * @param {WebMetricFilters} filters
     * @param {number[] | null} metricUserIds
     */
    async ExportUsersDataWithFilter(filters, metricUserIds) {
        return await SmrClient.FetchDownload({
            url: 'Metric/ExportUsersDataWithFilter',
            method: 'POST',
            body: { filters, metricUserIds }
        });
    }
}

export default new MetricsRequests;